// extracted by mini-css-extract-plugin
export default {"main":"Reading_main__27hHD","button_Reading":"Reading_button_Reading__UecRo"};